"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.description.placeholder': '输入项目描述',
};
